import { InvoiceInterface } from '@interfaces/invoice.interface';
import BaseApiClient from '../BaseApiClient';
import { ProductInterface } from '@interfaces/Product.interface';
import ProductDetailsInterface from '@interfaces/ProductDetails.interface';
import {
  AutoCompleteResolver,
  AutoCompleteItemResolver
} from '@ui/AutoCompleteField/types';

export class ApiProduct extends BaseApiClient {
  /**
   * Get all items
   */
  async all(): Promise<Array<ProductInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/product')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  autoCompleteResolver: AutoCompleteResolver = async (searchTerm) => {
    const data = await this.all();

    return data
      .filter((item) => {
        return (
          item.name &&
          item.name.toLowerCase().includes(searchTerm?.toLowerCase() || '')
        );
      })
      .map((item) => ({
        value: item.id,
        label: item.name || ''
      }));
  };

  autoCompleteItemResolver: AutoCompleteItemResolver = async (value) => {
    const item = await this.getProduct(value?.toString() || '');
    return {
      value: item.id,
      label: item.product.name ?? ''
    };
  };

  /**
   * Get product by uuid.
   */
  async getProduct(productUuid: string): Promise<ProductDetailsInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/products/${productUuid}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async storeDocument(
    productId: number,
    files: Array<File>
  ): Promise<InvoiceInterface> {
    return new Promise((resolve) => {
      const fd = new FormData();

      files.map((file) => {
        return fd.append('files[]', file, file.name);
      });

      this.client
        .post(`/products/${productId}/documents`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }
  async deleteProductDocuments(productId: number, ids: number[]) {
    return new Promise((resolve) => {
      this.client
        .delete(
          `/products/${productId}/documents?document_ids=${ids.slice(
            0,
            ids.length - 1
          )}`
        )
        .then((res) => resolve(res.data))
        .catch(console.error);
    });
  }
}

export { productQueryKeys } from './query-keys';
export { useProductAllQuery, useProductQuery } from './use-product-queries';
export {
  useProductDeleteDocumentsMutation,
  useProductStoreDocumentMutation
} from './use-product-mutations';
export type {
  ProductDeleteDocumentsVariables,
  ProductStoreDocumentVariables
} from './use-product-mutations';
